import { MQ_SMALL_ONLY, MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base4x5, medium3x2, small4x5 } = IMAGE_SIZES;

const base = {
  fallbackDims: base4x5,
  sourceSets: [
    {
      layoutWidth: { value: 92, units: 'px' },
      imageDims: base4x5,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 78, units: 'px' },
      imageDims: base4x5,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 55, units: 'px' },
      imageDims: small4x5,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 200, units: 'px' },
      imageDims: small4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0px)',
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = [
  {
    positionStart: 0,
    recurrence: 12,
    fallbackDims: base4x5,
    sourceSets: [
      {
        layoutWidth: { value: 367, units: 'px' },
        imageDims: medium3x2,
        media: MQ_MIDLARGE
      },
      {
        layoutWidth: { value: 310, units: 'px' },
        imageDims: medium3x2,
        media: MQ_LARGE
      },
      {
        layoutWidth: { value: 220, units: 'px' },
        imageDims: medium3x2,
        media: MQ_MEDIUM
      },
      {
        layoutWidth: { value: 200, units: 'px' },
        imageDims: small4x5,
        media: MQ_SMALL_ONLY
      }
    ],
    placeholders: [
      {
        media: MQ_MEDIUM,
        ratio: 3 / 2
      },
      {
        media: MQ_SMALL_ONLY,
        ratio: 4 / 5
      }
    ]
  }
];

export default {
  base,
  exceptionPatterns
};
